/*
 * Gestion des liens de pagination dans un conteneur avec la classe .js-ajax-content
 *
 * @event .js-ajax-content#pagination.done
 */

const pagination = () => {
    // Objet de cache pour stocker les données des différentes URLs
    const cache = {};

    // Gestion du clic sur les liens de pagination dans un conteneur avec la classe .js-ajax-content
    document.querySelectorAll('.js-ajax-content').forEach(container => {
        container.addEventListener('click', function (e) {
            const target = e.target.closest('.js-pagination-link');
            if (! target) {
                return;
            }

            // Empêche le comportement par défaut
            e.preventDefault();

            const containerElement = target.closest('.js-ajax-content');
            const paginationElement = containerElement.querySelector('.js-pagination');
            let url = paginationElement.dataset.url;
            url = `${SERVER_ROOT}include/tpl/GAB_LAFABRIQUE/${url}`;
            url += target.getAttribute('href').substring(target.getAttribute('href').indexOf('?'));

            // Ajout de l'idtf si nécessaire
            if (! url.includes('idtf=')) {
                url += url.includes('?') ? '&' : '?';
                url += 'idtf=' + document.querySelector('#document').dataset.idtf;
            }

            // Ajout du mode si nécessaire
            if (! url.includes('mode=')) {
                url += url.includes('?') ? '&' : '?';
                url += 'mode=' + document.querySelector('#document').dataset.mode;
            }

            // Vérifie si les données pour cette URL sont en cache
            if (cache[url]) {
                containerElement.innerHTML = cache[url];
                container.dispatchEvent(new Event('pagination.done'));
            } else {
                // Effectue une requête GET pour charger les données
                fetch(url)
                    .then(response => response.text())
                    .then(data => {
                        const parser = new DOMParser();
                        const parsedHTML = parser.parseFromString(data, 'text/html').querySelector('.js-ajax-content').innerHTML;

                        // Stockage dans le cache
                        cache[url] = parsedHTML;
                        containerElement.innerHTML = parsedHTML;
                    })
                    .finally(() => {
                        container.dispatchEvent(new Event('pagination.done'));
                    });
            }

            // Mise à jour de l'historique et du titre de la page
            window.history.replaceState({}, '', target.getAttribute('href'));

            const parentParagraph = containerElement.closest('div.paragraphe');
            const paginationNb = parentParagraph.querySelector('.js-pagination-nb');
            paginationNb.setAttribute('tabindex', '-1');
            paginationNb.focus();

            const pageNumber = target.dataset.page;
            document.title = `${document.title.substring(0, document.title.lastIndexOf('- Page'))}- Page ${pageNumber}`;
        });
    });
};

document.addEventListener('DOMContentLoaded', pagination);
